export function currentFiscalYear(date) {
    let year = date.getMonth() > 8 
        ? date.getFullYear() + 1
        : date.getFullYear()
    return year
}